import { useEffect, useState } from 'react';

import type { Payor } from 'interfaces';
import { getValueByPath } from 'utils/getValueByPath';

type ClaimPayor = Pick<Payor, 'province'>;
type ClaimForm = {
  getValues: () => unknown;
  watch: (path: string, callback: (event: { value: unknown }) => void) => void;
};

export const isSKClaim = (payor: ClaimPayor | null | undefined): boolean =>
  payor?.province === 'SK';

export const useIsSKClaim = (
  form: ClaimForm | null,
  prefix?: string
): boolean => {
  if (!form) {
    throw new Error('useIsSKClaim requires an active claim form');
  }

  const payorPath = prefix ? `${prefix}.payor` : 'payor';
  const currentPayor = getValueByPath(form.getValues(), payorPath) as
    | ClaimPayor
    | null
    | undefined;
  const currentIsSKClaim = isSKClaim(currentPayor);
  const [isSK, setIsSK] = useState<boolean>(currentIsSKClaim);

  form.watch(payorPath, ({ value }) => {
    setIsSK(isSKClaim(value as ClaimPayor | null | undefined));
  });

  useEffect(() => {
    setIsSK(currentIsSKClaim);
  }, [currentIsSKClaim, payorPath]);

  return isSK;
};
